import {
  MasterArtworkNumberActionType,
  MasterArtworkNumberActionTypes,
  MasterArtworkNumberState,
} from "./data.type";
import { MasterArtworkNameState } from "../artwork-name/data.type";
import { IMasterArtworkRequestHistory, MasterArtworkCollectionState } from "../collections/data.type";
import { IRequestStatusReason } from "../../../types/data.interface";

const setCode = (code: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_CODE,
  payload: { code },
});

export const setArtworkName = (
  artwork_name: MasterArtworkNameState | null,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_ARTWORK_NAME,
  payload: { artwork_name },
});

const setFileName = (
  file_name: string | null,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_FILE_NAME,
  payload: { file_name },
});

const setStatus = (status: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_STATUS,
  payload: { status },
});

const setComment = (comment: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_COMMENT,
  payload: { comment },
});

const setId = (id: number | string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_ID,
  payload: { id },
});

const setCollection = (collection: MasterArtworkCollectionState | null) => ({
  type: MasterArtworkNumberActionTypes.SET_COLLECTION,
  payload: { collection },
});

const setArtworkNumber = (
  artworkNumber: MasterArtworkNumberState,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_ARTWORK_NUMBER,
  payload: { ...artworkNumber },
});

const resetState = (): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.RESET_STATE,
  payload: {},
});

const setSubmitComment = (comment: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_SUBMIT_COMMENT,
  payload: { submitComment: comment },
});

const setApproveComment = (comment: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_APPROVE_COMMENT,
  payload: { approveComment: comment },
});

const setRejectComment = (comment: string): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_REJECT_COMMENT,
  payload: { rejectComment: comment },
});

const setRejectReason = (
  reason: IRequestStatusReason,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_REJECT_REASON,
  payload: { rejectReason: reason },
});

const setIsValid = (
  isValid: boolean | null,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_IS_VALID,
  payload: { isValid },
});

const setRequestStatus = (
  requestStatus: string | null,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_REQUEST_STATUS,
  payload: { requestStatus },
});

const setLaunchDate = (
  launch_date: string,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_LAUNCH_DATE,
  payload: { launch_date },
});

const setUnsavedChanges = (
  hasUnsavedChanges: boolean,
): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_UNSAVED_CHANGES,
  payload: { hasUnsavedChanges },
});

const setIsReadOnly = (isReadOnly: boolean): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.SET_IS_READ_ONLY,
  payload: { isReadOnly },
});

const resetAllData = (): MasterArtworkNumberActionType => ({
  type: MasterArtworkNumberActionTypes.RESET_STATE,
  payload: {},
});

export const MasterArtworkNumberActions = {
  setCode,
  setArtworkName,
  setFileName,
  setStatus,
  setComment,
  setId,
  setArtworkNumber,
  resetState,
  setCollection,
  setSubmitComment,
  setIsValid,
  setRejectReason,
  setRejectComment,
  setApproveComment,
  setRequestStatus,
  setUnsavedChanges,
  setIsReadOnly,
  resetAllData,
  setLaunchDate,
};
